import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Styles.css";

const HeroSection = ({ header, text }) => {
  return (
    <div className="contact-section">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <h1>{header}</h1>
            <p>{text}</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroSection;
